import { Print } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

import { MaterialReactTable } from "material-react-table";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearAppointmentSession } from "../../../../../../actions/appointments";
import CustomDialog from "../../../../../commons/dialog/customDialog";
import { tableConfig } from "../../../../../commons/table/config/tableConfig";
import { StyledAppointmetnsPrintSession } from "../../../../../styled/appointments";
import { StyledFormHeader } from "../../../../../styled/form";

const AppointmentPrintSession = ({ open, handleClose, handleSubmit }) => {

  const dispatch = useDispatch();

  const appointmentSession = useSelector(
    (state) => state.appointments.appointmentSession,
  );

  const [data, setData] = useState([]);

  const loadingTable = appointmentSession.data.sesionTurnos && !data.length;

  useEffect(() => {
    dispatch(clearAppointmentSession())
    if (appointmentSession.data.sesionTurnos) {
      setData(
        appointmentSession.data.sesionTurnos.map((s) => {
          const tableData = { checked: true };
          s.tableData = tableData;
          return s;
        }),
      );
    } else {
      setData([]);
    }
  }, [appointmentSession.data]);
  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <StyledAppointmetnsPrintSession.TitleContainer>
        <StyledAppointmetnsPrintSession.Title>
          IMPRIMIR SESION
        </StyledAppointmetnsPrintSession.Title>
        <Tooltip title="Cerrar">
          <StyledFormHeader.CloseIcon onClick={handleClose} />
        </Tooltip>
      </StyledAppointmetnsPrintSession.TitleContainer>
      <StyledAppointmetnsPrintSession.AppointmentsContainer>
        <div>
          <MaterialReactTable
            {...tableConfig}
            defaultColumn={{
              maxSize: 1,
            }}
            enableSelectAll
            enableRowSelection
            title="Turnos"
            state={{ isLoading: appointmentSession.isFetching || loadingTable }}
            columns={[
              {
                header: "N°",
                size: 50,
                accessorKey: "orden",
              },
              {
                header: "Día",
                size: 50,

                Cell: (rowData) => {
                  return moment(rowData.row.original.fechaHora).format(
                    "DD/MM/YYYY",
                  );
                },
              },
              {
                header: "Hora",
                size: 50,

                Cell: (rowData) =>
                  moment(rowData.row.original.fechaHora).format("HH:mm"),
              },
              {
                header: "Profesional",
                size: 50,

                Cell: (rowData) => appointmentSession.data.profesional,
              },
              {
                header: "Especialidad",
                size: 50,

                Cell: (rowData) => appointmentSession.data.especialidad,
              },
            ]}
            renderToolbarInternalActions={({ table }) => {

              const selectedRows = table.getSelectedRowModel().rows.map((row) => row.original);

              if (selectedRows.length > 0) {
                return (
                  <>
                    <Tooltip title="Imprimir Sesiónes">
                      <IconButton
                        onClick={() => handleSubmit(selectedRows)}
                        size="small"
                        color="inherit">
                        <Print />
                      </IconButton>
                    </Tooltip>

                  </>
                );
              }

              return null;

            }}
            data={data}
          />
        </div>
      </StyledAppointmetnsPrintSession.AppointmentsContainer>
    </CustomDialog>
  );
};

export default AppointmentPrintSession;
